import { FontIcon, ITooltipHostStyles, Stack, TooltipHost, TooltipOverflowMode, css, mergeStyleSets } from '@fluentui/react';
import { SharedColors } from '@fluentui/theme';
import * as React from 'react';
import { IInspectionConfig, IInspectionConfigUI } from '@piceasoft/core';
type TStateProps = {
    config: IInspectionConfig<IInspectionConfigUI>
    description?: string
    icon?: string
}

export const DiagnosticsState: React.FC<TStateProps> = (props) => {
    return (
        <Stack tokens={{ childrenGap: 24 }}>
            <Stack.Item style={{ color: SharedColors.gray40 }}>
                <TooltipHost 
                    overflowMode={TooltipOverflowMode.Self}
                    content={props.config.ui?.description ?? props.description}
                    styles={tooltipStyles}
                    hostClassName={css(styles.title)}
                >
                    {props.config.ui?.description ?? props.description}
                </TooltipHost>
            </Stack.Item>
            <Stack.Item>
                <Stack>
                    <Stack horizontalAlign="center">
                        <FontIcon iconName={props.icon ?? "Medical"} style={{ fontSize: 128, height: 128, width: 128, color: SharedColors.gray20 }} />
                    </Stack>
                </Stack>
            </Stack.Item>
        </Stack>
    )
}

const styles = mergeStyleSets({
    title: [
        {
            overflow: 'hidden',
            overflowWrap: "break-word",
            maxHeight: 60,
        }
    ]
}) 

const tooltipStyles: Partial<ITooltipHostStyles> = {
    root: { display: 'block' }
}